import { IOffer } from '../../../../types/offerData';
import { getOfferType } from '../../../../utils/offer_type';
import { getSpecialties, ISpecialtyView } from './getSpecialties';
import { shouldSpecialtyRender } from './shouldSpecialtyRender';

export function getSpecialtyPrepared(offer: IOffer): ISpecialtyView | null {
  const offerType = getOfferType(offer);

  const specialties = getSpecialties(offer.specialty);

  return shouldSpecialtyRender({
    specialty: offer.specialty,
    specialtiesString: specialties.specialtiesString,
    offerType,
  })
    ? specialties
    : null;
}
